/**
 * Classe view da entidade de Stops
 */

App.Views.Stop = {

    populatePlacementFieldAndListStops: function (routeId) {
        this.populatePlacementField(routeId);
        this.populateListStops(routeId);

    },

    resetPlacementField: function() {
      const stopFields = App.Forms.Stop.form.fields;
      const selectListStops = stopFields.relatedStop.input;
      const placementField = stopFields.placement;

      placementField.input.value = "BEST_INSERTION";
      selectListStops.parentElement.setAttribute("style", "display: none");
    },

    populatePlacementField: function (routeId) {

        var placementField = App.Forms.Stop.form.fields.placement.input,
            containsStop   = 0,
            options        = Greenmile.Utils.StopPlacement.getDataToOption(),
            length         = options.value.length;

        Monet.Session = Monet.Session || {};
        Monet.Session.TreeviewRoute = Monet.Session.TreeviewRoute || {};

        if (Monet.Session.TreeviewRoute[routeId] && Monet.Session.TreeviewRoute[routeId].stops) {
            containsStop = Monet.Session.TreeviewRoute[routeId].stops.size();
        }

        placementField.innerHTML = "";

        for (var i = 0; i < length; i++) {

            var value = options.value[i];
            var showValue = Monet.I18n.getResourcesByKey(options.showValue[i]);
            var option = document.createElement("option");

            option.value = value;
            option.text = showValue;

            if (value === "LAST") {

                option.setAttribute("selected", "selected");

            }

            if (value === "AFTER_STOP" || value === "BEFORE_STOP") {

                if (containsStop > 0) {

                    placementField.appendChild(option);
                }

            } else {

                placementField.appendChild(option);
            }
        }

        this.addEventListenersToPlacementField(placementField, routeId);

    },

    addEventListenersToPlacementField: function (placementField, routeId) {
      if (placementField !== null) {
        let selectListStops = App.Forms.Stop.form.fields.relatedStop.input;

        const showListOfStops = function () {
          selectListStops.parentElement.setAttribute(
            'style',
            'display: block'
          );
        };

        const hideListOfStops = function () {
          selectListStops.parentElement.setAttribute(
            'style',
            'display: none'
          );
        };

        const placementEvenListenner = ({ target }) => {
          const value = target.value;

          if (value === 'BEFORE_STOP' || value === 'AFTER_STOP') {
            showListOfStops();
          } else {
            hideListOfStops();
          }

          this.populateListStops(routeId);
        };

        placementField.removeEventListener('change', placementEvenListenner);
        placementField.addEventListener('change', placementEvenListenner);
      } else {
        const error = new Monet.Exception.ReturnError(
          this,
          'No placementField to add on form.'
        );
        error.console();
      }
    },

    populateListStops: function (routeId) {
      let arrayOptionStops = new App.Collections.BaseCollection();

      if (Monet.Session.TreeviewRoute[routeId]) {
        arrayOptionStops = Monet.Session.TreeviewRoute[routeId].stops;
      }

      const stopsLength = arrayOptionStops.size();
      const selectListStops = App.Forms.Stop.form.fields.relatedStop.input;

      selectListStops.innerHTML = '';

      for (let i = 0; i < stopsLength; i++) {
        const attributes = arrayOptionStops.at(i).attributes;
        const value = attributes.id;
        let showValue = attributes.key;

        if (attributes.location) {
          showValue =
            attributes.location.description || attributes.location.key;
        }

        if (value && showValue) {
          const option = document.createElement('option');

          option.value = value;
          option.text = showValue;
          selectListStops.appendChild(option);
        }
      }
    },

    // TODO: Alterar para uma classe utilitária
    clearFieldsToForm: function () {

        App.Forms.Stop.form.clearAllFields();

    }
};
